module.exports = __webpack_public_path__ + "img/tcb-cup.db2f8c5f.png";